<ng-template #dependentPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closePopup()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle">
            {{qualityService.moduleFullName}}&nbsp;{{idMapping[qualityService.moduleName]}}&nbsp;Dependent(s)
        </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="center no-data" style="margin: 5px; font-weight: 550; font-style: italic;" *ngIf="!gridLength">
        There are no dependents on this module
    </div>
    <div *ngIf="gridLength" style="margin:5px;">
        <ng-container>
            <app-dynamic-grid *ngIf="gridConfig && gridClause && gridTrail && gridReport && gridSettings"
                [config]="gridConfig" [clauses]="gridClause" [trail]="gridTrail" [report]="gridReport"
                [settings]="gridSettings" (refreshed)="onGridRefresh($event)"></app-dynamic-grid>
        </ng-container>
    </div>
</ng-template>